
    <h2 mat-dialog-title style="font-size:1.4em;">{{ data.title }}</h2>
    <div mat-dialog-content>
      <p style="margin-bottom:16px;">
        {{ data.description }}
        Select a future trip to move them to:
      </p>
      <mat-radio-group [(ngModel)]="selectedTripId" style="display:flex;flex-direction:column;gap:10px;">
        <mat-radio-button *ngFor="let trip of data.futureTrips" [value]="trip.job_id"
          style="display:flex;align-items:center;">
          <span style="font-weight:500;min-width:100px;">{{ trip.schedule_date | date:'MMM d, y' }}</span>
          <span style="margin:0 8px;">—</span>
          <span style="flex:1;">{{ trip.customer_jobtype }}</span>
          <span style="margin-left:8px;font-size:0.85em;color:#666;">({{ trip.job_status }})</span>
        </mat-radio-button>
      </mat-radio-group>
      <mat-form-field *ngIf="data.requireReason" appearance="outline" style="width:100%;margin-top:16px;">
        <mat-label>Reason</mat-label>
        <textarea matInput [(ngModel)]="reason" rows="2"
          placeholder="Why are these jobs being moved to a future trip?"></textarea>
      </mat-form-field>
    </div>
    <div mat-dialog-actions align="end" style="gap:8px;">
      <button mat-stroked-button (click)="dialogRef.close(null)">Skip</button>
      <button mat-flat-button color="primary"
        [disabled]="!selectedTripId || (data.requireReason && !reason.trim())"
        (click)="dialogRef.close({ tripId: selectedTripId, reason: reason.trim() })">Reassign</button>
    </div>
  